import { mapInsurerRolesToSelectOptions } from '~/constants/insurerRoles';

export default {
    data() {
        return {
            insurerRoleOptions: [],
        };
    },
    methods: {
        loadInsurerRoleOptions() {
            if (this.insurerRoleOptions.length > 0) {
                return Promise.resolve();
            }
            return axios.get(this.$root.api('insurer-roles'))
                .then(res => {
                    this.insurerRoleOptions = mapInsurerRolesToSelectOptions(res.data.data);
                });
        },
    },
};
